  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.gdpAlmondGuideReady === 'true') return;
      root.dataset.gdpAlmondGuideReady = 'true';

    const track = (event, parameters = {}) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const queue = window.dataLayer = window.dataLayer || [];
      if (typeof queue.push === 'function') queue.push({ event, ...parameters });
    };

    const form = root.querySelector('[data-quiz-form]');
    const results = root.querySelector('[data-results]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const progress = root.querySelector('[data-progress]');
    const stepLabel = root.querySelector('[data-step-label]');
    const next = root.querySelector('[data-next]');
    const nextCopy = root.querySelector('[data-next-copy]');
    const back = root.querySelector('[data-back]');
    const status = root.querySelector('[data-status]');
    let step = 1;
    let started = false;
    let completed = false;
    let previousFamily = '';

    const activeFieldset = () => root.querySelector(`[data-step="${step}"]`);
    const checked = (fieldset = activeFieldset()) => fieldset?.querySelector('input[type="radio"]:checked');
    const answer = (question) => root.querySelector(`[data-question="${question}"] input[type="radio"]:checked`)?.value || '';
    const family = () => answer('family');

    const setBranch = (fieldset, key) => {
      fieldset.querySelectorAll('[data-branch]').forEach((branch) => {
        const active = branch.dataset.branch === key;
        branch.hidden = !active;
        branch.querySelectorAll('input').forEach((input) => { input.disabled = !active; });
      });
    };

    const prepareAdaptiveStep = () => {
      if (step === 2) {
        const fieldset = activeFieldset();
        setBranch(fieldset, family());
        fieldset.querySelector('[data-adaptive-legend]').textContent = family() === 'sweet'
          ? 'Quel profil sucré vous attire le plus ?'
          : family() === 'savory'
            ? 'Quel caractère vous attire le plus ?'
            : 'Quel parcours voulez-vous ouvrir ?';
      }
      if (step === 3) {
        const fieldset = activeFieldset();
        setBranch(fieldset, family() === 'both' ? 'both' : 'standard');
        fieldset.querySelector('[data-adaptive-legend]').textContent = family() === 'both'
          ? 'Jusqu’où voulez-vous pousser la découverte ?'
          : 'Combien de saveurs voulez-vous découvrir ?';
        const curatedTitle = fieldset.querySelector('[data-curated-title]');
        const curatedHelp = fieldset.querySelector('[data-curated-help]');
        const customProfile = answer('profile') === 'custom';
        if (curatedTitle) curatedTitle.textContent = customProfile ? 'Conserver la libre composition' : 'Un trio déjà composé';
        if (curatedHelp) curatedHelp.textContent = customProfile ? 'Je poursuis vers les options proposées' : 'Trois saveurs distinctes, prêtes à comparer';
      }
    };

    const renderStep = (focus = false) => {
      steps.forEach((fieldset) => { fieldset.hidden = Number(fieldset.dataset.step) !== step; });
      prepareAdaptiveStep();
      if (progress) {
        progress.value = step;
        progress.textContent = `${step} sur 3`;
      }
      if (stepLabel) stepLabel.textContent = `Question ${step} sur 3`;
      if (nextCopy) nextCopy.textContent = step === 3 ? 'Voir ma sélection' : 'Continuer';
      if (next) next.disabled = !checked();
      if (back) back.hidden = step === 1;
      const legend = activeFieldset()?.querySelector('legend');
      if (status && legend) status.textContent = `Question ${step} sur 3 : ${legend.textContent}`;
      if (focus && legend) legend.focus({ preventScroll: true });
    };

    const resultKey = () => {
      const selectedFamily = family();
      const profile = answer('profile');
      const format = answer('format');
      if (format === 'all') return 'integrale';
      if (format === 'custom') return 'custom';
      if (selectedFamily === 'both' && format === 'curated') {
        return { sweet_trio: 'trio_sucre', discovery_trio: 'trio_decouverte', savory_trio: 'trio_sale', custom: 'custom' }[profile] || 'trio_decouverte';
      }
      if (format === 'three') return selectedFamily === 'sweet' ? 'trio_sucre' : 'trio_sale';
      return {
        warm: 'cannelle', deep: 'chocolat', soft: 'coco', fruity: 'framboise',
        cheese: 'edam', spiced: 'piment', smoked: 'fumees', sharp: 'wasabi'
      }[profile] || 'trio_decouverte';
    };

    const matchSentence = () => {
      const familyLabel = { sweet: 'une envie sucrée', savory: 'une envie salée et épicée', both: 'une envie de contrastes' }[family()];
      const profileLabel = {
        warm: 'une chaleur douce', deep: 'une rondeur chocolatée', soft: 'une douceur parfumée', fruity: 'un éclat fruité',
        cheese: 'une note fromagère', spiced: 'une chaleur épicée', smoked: 'un sillage fumé', sharp: 'une pointe vive',
        sweet_trio: 'un parcours tout en douceur', discovery_trio: 'un passage du doux au salé', savory_trio: 'un parcours salé et épicé', custom: 'une composition libre'
      }[answer('profile')];
      const formatLabel = answer('format') === 'curated' && answer('profile') === 'custom'
        ? 'la poursuite vers une composition libre'
        : { one: 'le choix d’une seule saveur', three: 'la comparaison de trois saveurs', curated: 'un trio déjà composé', all: 'la découverte des huit saveurs', custom: 'une composition choisie librement' }[answer('format')];
      return `Votre parcours réunit ${familyLabel}, ${profileLabel} et ${formatLabel}.`;
    };

    const showResult = () => {
      const key = resultKey();
      const selected = root.querySelector(`[data-result="${key}"]`);
      root.querySelectorAll('[data-result]').forEach((item) => { item.hidden = true; });
      if (!selected || completed) return;
      completed = true;
      selected.hidden = false;
      selected.querySelector('[data-match]').textContent = matchSentence();
      form.hidden = true;
      results.hidden = false;
      selected.querySelector('h3')?.focus({ preventScroll: true });
      if (status) status.textContent = `Votre sélection recommandée : ${selected.querySelector('h3')?.textContent || ''}`;
      track('almond_quiz_complete', { result_handle: selected.dataset.resultHandle, family: family(), format: answer('format') });
    };

    if (form && results && steps.length === 3 && next && back) {
      form.hidden = false;
      form.addEventListener('submit', (event) => event.preventDefault());
      renderStep(false);
      form.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        if (step === 1) {
          if (!started) { track('almond_quiz_start', { entry_section: 'guide' }); started = true; }
          if (previousFamily && previousFamily !== family()) {
            root.querySelectorAll('[data-step="2"] input,[data-step="3"] input').forEach((input) => { input.checked = false; });
          }
          previousFamily = family();
        }
        if (step === 2) {
          root.querySelectorAll('[data-step="3"] input').forEach((input) => { input.checked = false; });
        }
        next.disabled = false;
      });
      next.addEventListener('click', () => {
        if (step === 3 && completed) return;
        const selected = checked();
        if (!selected) {
          if (status) status.textContent = 'Choisissez une réponse avant de continuer.';
          return;
        }
        track('almond_quiz_step', { step, answer_key: selected.value });
        if (step === 3) { showResult(); return; }
        step += 1;
        renderStep(true);
      });
      back.addEventListener('click', () => {
        if (step === 1) return;
        step -= 1;
        renderStep(true);
      });
      root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-restart]')) return;
        const previousResult = root.querySelector('[data-result]:not([hidden])')?.dataset.resultHandle || '';
        track('almond_quiz_restart', { previous_result: previousResult });
        form.reset();
        root.querySelectorAll('[data-branch] input').forEach((input) => { input.disabled = false; });
        step = 1;
        started = false;
        completed = false;
        previousFamily = '';
        results.hidden = true;
        form.hidden = false;
        renderStep(false);
        activeFieldset()?.querySelector('legend')?.focus({ preventScroll: true });
      });
    }

    const filterButtons = [...root.querySelectorAll('[data-filter]')];
    const flavorCards = [...root.querySelectorAll('[data-flavor-card]')];
    const flavorGrid = root.querySelector('.gdp-aq__flavors');
    const filterStatus = root.querySelector('[data-filter-status]');
    let flavorExpanded = false;
    let flavorToggle = root.querySelector('[data-flavor-toggle]');

    flavorCards.forEach((card, index) => {
      if (index > 3) card.dataset.flavorExtra = '';
    });

    if (!flavorToggle && flavorGrid && flavorCards.length > 4) {
      if (!flavorGrid.id) flavorGrid.id = `${root.id || 'gdp-almond-guide'}-flavors`;
      flavorToggle = document.createElement('button');
      flavorToggle.type = 'button';
      flavorToggle.className = 'gdp-aq__flavor-toggle';
      flavorToggle.dataset.flavorToggle = '';
      flavorToggle.setAttribute('aria-expanded', 'false');
      flavorToggle.setAttribute('aria-controls', flavorGrid.id);
      flavorToggle.innerHTML = '<span data-flavor-toggle-label>Voir les 8 saveurs</span><span class="gdp-aq__flavor-toggle-mark" aria-hidden="true">+</span>';
      flavorGrid.insertAdjacentElement('afterend', flavorToggle);
    }

    const renderFlavors = (key = 'all') => {
      flavorCards.forEach((card, index) => {
        const matches = key === 'all' || card.dataset.categories.split(' ').includes(key);
        const beyondPreview = key === 'all' && index > 3 && !flavorExpanded;
        card.hidden = !matches || beyondPreview;
      });
      if (flavorToggle) {
        if (key === 'all') flavorToggle.removeAttribute('hidden');
        else flavorToggle.setAttribute('hidden', '');
        flavorToggle.setAttribute('aria-expanded', String(flavorExpanded));
        const label = flavorToggle.querySelector('[data-flavor-toggle-label]');
        if (label) label.textContent = flavorExpanded ? 'Réduire la sélection' : 'Voir les 8 saveurs';
      }
      const visibleCount = flavorCards.filter((card) => !card.hidden).length;
      if (filterStatus) filterStatus.textContent = `${visibleCount} saveur${visibleCount > 1 ? 's' : ''} affichée${visibleCount > 1 ? 's' : ''}.`;
    };

    const applyFilter = (key, shouldTrack = true) => {
      if (key !== 'all') flavorExpanded = false;
      filterButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
      renderFlavors(key);
      if (shouldTrack) track('almond_filter_use', { filter_key: key });
    };

    filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
    flavorToggle?.addEventListener('click', () => {
      flavorExpanded = !flavorExpanded;
      renderFlavors('all');
      track('almond_flavor_expand', { expanded: flavorExpanded });
    });
    applyFilter('all', false);
    requestAnimationFrame(() => applyFilter('all', false));
    root.querySelectorAll('[data-path-filter]').forEach((button) => button.addEventListener('click', () => {
      applyFilter(button.dataset.pathFilter);
      root.querySelector('[data-gdp-aq-atlas]')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));

    root.addEventListener('click', (event) => {
      const pdp = event.target.closest('[data-pdp-link]');
      if (pdp) track('almond_guide_pdp_click', { product_handle: pdp.dataset.productHandle, source_section: pdp.dataset.source, result_or_browse: pdp.dataset.resultOrBrowse });
      const assortment = event.target.closest('[data-assortment-link]');
      if (assortment) track('almond_assortment_click', { product_handle: assortment.dataset.productHandle });
    });

    const trackGuideView = () => {
      if (window.__gdpAlmondGuideViewSent) return;
      window.__gdpAlmondGuideViewSent = true;
      track('almond_guide_view', { page_type: 'guide', device_group: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop' });
    };
    if ('IntersectionObserver' in window) {
      const viewObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        trackGuideView();
        observer.disconnect();
      }, { threshold: 0.1 });
      viewObserver.observe(root);
    } else {
      trackGuideView();
    }
    };

    const boot = (scope = document) => {
      const roots = [];
      if (scope.matches?.('[data-gdp-aq-root]')) roots.push(scope);
      scope.querySelectorAll?.('[data-gdp-aq-root]').forEach((candidate) => roots.push(candidate));
      roots.forEach(initialize);
    };

    const start = () => boot(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    if (!window.__gdpAlmondGuideSectionListener) {
      window.__gdpAlmondGuideSectionListener = true;
      document.addEventListener('shopify:section:load', (event) => boot(event.target));
    }
  })();
